<div class="background-form" *ngIf="clientInfo && !invalidToken">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-3 p-0">
        <div class="client-info p-5">
          <img src="assets/images/logo.png" alt="Diagnostic Learning Services Logo" width="150" class="img-fluid mb-5">
          <h4 class="text-grey">Appointment Information</h4>
          <hr>
          <div class="detail">
            <ul>
              <li>
                <label>Name</label>
                <p>{{clientInfo.clientName}}</p>
              </li>
              <li>
                <label>Appointment Date/Time</label>
                <p>{{clientInfo.appointmentDate}} (CST)</p>
              </li>
              <li>
                <label>Location</label>
                <p>{{clientInfo.Location}}</p>
              </li>

            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-9 px-0">
        <div class="form bg-white p-4">
          <h4 class="text-green">Assessment Information</h4>
          <p class="alert alert-warning my-4">Please complete the following like <em>this is the first time you have
              shared this information with us.</em> This information WILL NOT bias the assessment but it will ensure
            that we address all of your concerns.</p>
          <!-- <p><small class="text-danger"><em>All fields are mandatory.</em></small></p> -->
          <form [formGroup]="answersForm" class="custom-form">
            <div id="questionsBank" class="input-outer rounded bg-purple-light py-3 mt-4">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6">
                    <label for="dateOfBirth">Date Of Birth *</label>
                    <input type="test" formControlName="dateOfBirth" placeholder="Date of Birth" min="1950-01-01"
                      max="3000-01-01" onfocus=" this.type='date',this.max=new Date().toISOString().split('T')[0]">
                  </div>
                  <div class="col-md-6">
                    <label for="currentSchool">Current School *</label>
                    <input type="text" formControlName="currentSchool" placeholder="Current School">
                  </div>
                </div>
              </div>
              <div class="col-12">
                <label for="question1">If your child speaks, is spoken to, or learns in a language other than English,
                  please note what language(s) here:</label>
                <textarea formControlName="answer1" rows="1"></textarea>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6">
                    <label for="question27">Primary area of Concern/Reason for assessment *</label>
                    <select formControlName="answer27">
                      <option value="" selected disabled>Select Option</option>
                      <option value="Dyslexia">Dyslexia</option>
                      <option value="Reading Comprehension">Reading Comprehension</option>
                      <option value="Reading Fluency">Reading Fluency</option>
                      <option value="Dysgraphia">Dysgraphia</option>
                      <option value="Written Expression">Written Expression</option>
                      <option value="Spelling">Spelling</option>
                      <option value="Dyscalculia">Dyscalculia</option>
                      <option value="Math Calculations">Math Calculations</option>
                      <option value="Math Word Problems">Math Word Problems</option>
                      <option value="Attention/Focus">Attention/Focus</option>
                      <option value="Hyperactivity/Impulsivity">Hyperactivity/Impulsivity</option>
                      <option value="ADHD">ADHD</option>
                      <option value="Memory">Memory</option>
                      <option value="Processing Skills">Processing Skills</option>
                      <option value="Test Taking/Test Anxiety">Test Taking/Test Anxiety</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label for="question28">Additional area of Concern/Reason for assessment</label>
                    <select formControlName="answer28">
                      <option value="" selected disabled>Select Option</option>
                      <option value="Dyslexia">Dyslexia</option>
                      <option value="Reading Comprehension">Reading Comprehension</option>
                      <option value="Reading Fluency">Reading Fluency</option>
                      <option value="Dysgraphia">Dysgraphia</option>
                      <option value="Written Expression">Written Expression</option>
                      <option value="Spelling">Spelling</option>
                      <option value="Dyscalculia">Dyscalculia</option>
                      <option value="Math Calculations">Math Calculations</option>
                      <option value="Math Word Problems">Math Word Problems</option>
                      <option value="Attention/Focus">Attention/Focus</option>
                      <option value="Hyperactivity/Impulsivity">Hyperactivity/Impulsivity</option>
                      <option value="ADHD">ADHD</option>
                      <option value="Memory">Memory</option>
                      <option value="Processing Skills">Processing Skills</option>
                      <option value="Test Taking/Test Anxiety">Test Taking/Test Anxiety</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <label for="question2">Please tell us specifically what has led to your concerns noted above. This can
                  be your own observations as well as information from teachers/tutors. (Please be as specific as
                  possible, this information will help us plan for your student's assessment) *</label>
                <textarea formControlName="answer2" rows="3"></textarea>
              </div>
              <div class="col-12">
                <label for="question3">If your child has been diagnosed with any type of learning disability, ADHD,
                  speech/language impairment, or physical disability, please indicate the type of diagnosis they have
                  received.</label>
                <textarea formControlName="answer3" rows="1"></textarea>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6">
                    <label for="question4">Is your student receiving support through any of the following programs?
                      *</label>
                    <select formControlName="answer4">
                      <option value="" selected disabled>Select Option</option>
                      <option value="Section 504">Section 504</option>
                      <option value="Special Education">Special Education</option>
                      <option value="RTI (Response to Intervention)">RTI (Response to Intervention)</option>
                      <option value="Private School Accommodations/Learning Lab">Private School Accommodations/Learning
                        Lab</option>
                      <option value="None">None</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label for="question5">Please tell us the type of support and what accommodations they are currently
                      receiving.</label>
                    <textarea formControlName="answer5" rows="2"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6">
                    <label for="question6">Has your student ever repeated a grade? *</label>
                    <select formControlName="answer6">
                      <option value="" selected disabled>Select Option</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label for="question7">If Yes, what grade?</label>
                    <textarea formControlName="answer7" rows="1"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <label for="question8">Have there been any significant changes in the studentʼs life over the past 3
                  years? (separation, Divorce, birth of a sibling, death of a close relative, move, change of schools,
                  etc) *</label>
                <textarea formControlName="answer8" rows="3"></textarea>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6">
                    <label for="question9">Does your child have any specific medical conditions not mentioned above?
                      *</label>
                    <select formControlName="answer9">
                      <option value="" selected disabled>Select Option</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label for="question10">If yes, please describe:</label>
                    <textarea formControlName="answer10" rows="2"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6">
                    <label for="question11">Does your child regularly take any prescription medications? *</label>
                    <select formControlName="answer11">
                      <option value="" selected disabled>Select Option</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label for="question12">If yes, please describe:</label>
                    <textarea formControlName="answer12" rows="2"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <label for="question13">Were there any complications during pregnancy or delivery? *</label>
                <textarea formControlName="answer13" rows="3"></textarea>
              </div>
              <div class="col-12">
                <label for="question14">Were all developmental milestones (crawling, walking, talking) met on time? If
                  no, please describe: *</label>
                <textarea formControlName="answer14" rows="3"></textarea>
              </div>
              <div class="col-12">
                <label for="question15">Is there a family history of any Learning Disabilities, ADHD, Depression, or
                  Anxiety? *</label>
                <textarea formControlName="answer15" rows="3"></textarea>
              </div>
              <div class="col-12">
                <label for="question16">Please describe your childʼs grades for this school year. *</label>
                <textarea formControlName="answer16" rows="3"></textarea>
              </div>
              <div class="col-12">
                <label for="question17">Please describe your childʼs grades for the 2-3 years prior to this school year.
                  *</label>
                <textarea formControlName="answer17" rows="3"></textarea>
              </div>
              <div class="col-12">
                <label for="question18">Please describe your child's attitude towards school. Do they love it, hate it,
                  are somewhere in between, or just love it for the social/sports aspects? *</label>
                <textarea formControlName="answer18" rows="3"></textarea>
              </div>
              <div class="col-12">
                <label for="question19">What subjects or classes does your child enjoy the most? *</label>
                <textarea formControlName="answer19" rows="3"></textarea>
              </div>
              <div class="col-12">
                <label for="question20">What subjects or classes are most difficult for your child? *</label>
                <textarea formControlName="answer20" rows="3"></textarea>
              </div>
            </div>


            <div id="checkboxBank" class="checkbox-outer rounded bg-theme-light py-3 mt-4">
              <div class="col-12">
                <h5>Please indicate your level of concern for each of the following behaviors:</h5>
              </div>
              <div class="col-12">
                <div class="bg-white border rounded table-responsive mt-4">
                  <table class="bg-white">
                    <thead>
                      <tr>
                        <th>List of concerns</th>
                        <th>No Concerns</th>
                        <th>Mild Concerns</th>
                        <th>Definite Concerns</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr id="1">
                        <td>Concentrate when reading</td>

                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" formControlName="concentrateWhenReading" name="concentrateWhenReading"
                              class="custom-control-input" value="1">
                            <label class="custom-control-label" for="concentrateWhenReading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" formControlName="concentrateWhenReading" name="concentrateWhenReading"
                              class="custom-control-input" value="2">
                            <label class="custom-control-label" for="concentrateWhenReading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" formControlName="concentrateWhenReading" name="concentrateWhenReading"
                              class="custom-control-input" value="3">
                            <label class="custom-control-label" for="concentrateWhenReading"></label>
                          </div>
                        </td>
                      </tr>


                      <tr id="1">
                        <td>Avoid distractions</td>

                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="avoidDistractions" formControlName="avoidDistractions"
                              class="custom-control-input" value="1">
                            <label class="custom-control-label" for="avoidDistractions"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="avoidDistractions" formControlName="avoidDistractions"
                              class="custom-control-input" value="2">
                            <label class="custom-control-label" for="avoidDistractions"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="avoidDistractions" formControlName="avoidDistractions"
                              class="custom-control-input" value="3">
                            <label class="custom-control-label" for="avoidDistractions"></label>
                          </div>
                        </td>
                      </tr>
                      <tr id="1">



                        <td>Pay attention during a boring task</td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="payAttentionInBoringClass"
                              formControlName="payAttentionInBoringClass" class="custom-control-input" value="1">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="payAttentionInBoringClass"
                              formControlName="payAttentionInBoringClass" class="custom-control-input" value="2">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="payAttentionInBoringClass"
                              formControlName="payAttentionInBoringClass" class="custom-control-input" value="3">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                      </tr>

                      <tr id="1">
                        <td>Think before acting</td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="thinkBeforeAct" formControlName="thinkBeforeAct"
                              class="custom-control-input" value="1">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="thinkBeforeAct" formControlName="thinkBeforeAct"
                              class="custom-control-input" value="2">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="thinkBeforeAct" formControlName="thinkBeforeAct"
                              class="custom-control-input" value="3">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                      </tr>
                      <tr id="1">
                        <td>Wait for his/her turn</td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="waitForTurn" formControlName="waitForTurn"
                              class="custom-control-input" value="1">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="waitForTurn" formControlName="waitForTurn"
                              class="custom-control-input" value="2">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="waitForTurn" formControlName="waitForTurn"
                              class="custom-control-input" value="3">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                      </tr>
                      <tr id="1">
                        <td>Start something without being asked</td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="startWithoutAsked" formControlName="startWithoutAsked"
                              class="custom-control-input" value="1">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="startWithoutAsked" formControlName="startWithoutAsked"
                              class="custom-control-input" value="2">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="startWithoutAsked" formControlName="startWithoutAsked"
                              class="custom-control-input" value="3">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                      </tr>
                      <tr id="1">
                        <td>Complete one task before starting a new one</td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="completeTask" formControlName="completeTask"
                              class="custom-control-input" value="1">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="completeTask" formControlName="completeTask"
                              class="custom-control-input" value="2">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="completeTask" formControlName="completeTask"
                              class="custom-control-input" value="3">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                      </tr>
                      <tr id="1">
                        <td>Get and stay organised</td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="stayOrganised" formControlName="stayOrganised"
                              class="custom-control-input" value="1">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="stayOrganised" formControlName="stayOrganised"
                              class="custom-control-input" value="2">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="stayOrganised" formControlName="stayOrganised"
                              class="custom-control-input" value="3">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                      </tr>
                      <tr id="1">
                        <td>Keep track of time</td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="keepTrackOfTime" formControlName="keepTrackOfTime"
                              class="custom-control-input" value="1">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="keepTrackOfTime" formControlName="keepTrackOfTime"
                              class="custom-control-input" value="2">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="keepTrackOfTime" formControlName="keepTrackOfTime"
                              class="custom-control-input" value="3">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                      </tr>

                      <tr id="1">
                        <td>Remember instructions with many steps</td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="rememberInstructions" formControlName="rememberInstructions"
                              class="custom-control-input" value="1">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="rememberInstructions" formControlName="rememberInstructions"
                              class="custom-control-input" value="2">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="rememberInstructions" formControlName="rememberInstructions"
                              class="custom-control-input" value="3">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                      </tr>

                      <tr id="1">
                        <td>Remember what he/she has read</td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="rememberRead" formControlName="rememberRead"
                              class="custom-control-input" value="1">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="rememberRead" formControlName="rememberRead"
                              class="custom-control-input" value="2">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="rememberRead" formControlName="rememberRead"
                              class="custom-control-input" value="3">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                      </tr>
                      <tr id="1">
                        <td>Control emotions under stress</td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="controlEmotions" formControlName="controlEmotions"
                              class="custom-control-input" value="1">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="controlEmotions" formControlName="controlEmotions"
                              class="custom-control-input" value="2">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                        <td>
                          <div class="custom-control custom-radio">
                            <input type="radio" name="controlEmotions" formControlName="controlEmotions"
                              class="custom-control-input" value="3">
                            <label class="custom-control-label" for="Concentrate_when_reading"></label>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div id="questionsBank" class="input-outer rounded bg-purple-light py-3 mt-4">
              <div class="col-12">
                <label for="question21">What are some strengths of your child both in and outside of school? *</label>
                <textarea formControlName="answer21" rows="3"></textarea>
              </div>
              <div class="col-12">
                <label for="question22">Please describe things that your child enjoys doing outside of school? *</label>
                <textarea formControlName="answer22" rows="3"></textarea>
              </div>
              <div class="col-12">
                <label for="question23">How does your child relate to their peers? *</label>
                <textarea formControlName="answer23" rows="3"></textarea>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-md-4">
                    <label for="question24">Would you like us to contact your student's teacher for additional
                      information? *</label>
                    <select formControlName="answer24">
                      <option value="" selected disabled>Select Option</option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label for="question25">If yes, Teacher's name</label>
                    <textarea formControlName="answer25" rows="2"></textarea>
                  </div>
                  <div class="col-md-4">
                    <label for="question26">Teacher's email</label>
                    <textarea formControlName="answer26" rows="2"></textarea>
                    <small class="text-danger"
                      *ngIf="answersForm.get('answer26')?.touched || answersForm.get('answer26')?.dirty">
                      <span *ngIf="answersForm.get('answer26')?.errors?.['pattern']">Please enter a valid email address
                        (only one)</span>
                    </small>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <label for="backgroundFormComment">Referred By *</label>
                <textarea formControlName="backgroundFormComment" rows="3"></textarea>
              </div>
              <div class="col-12" *ngIf="isMinor">
                <hr>
                <div class="legal-guardian-section bg-purple-light p-4 mt-3 rounded">
                  <h5 class="mb-3">Please list <strong><u>all individuals</u></strong> who have <strong>legal educational decision-making rights</strong> for this student.</h5>
                  
                  <div formArrayName="guardians">
                    <div *ngFor="let guardian of guardians.controls; let i=index" [formGroupName]="i" class="guardian-entry mb-3 p-3 bg-white border rounded">
                      <div class="row align-items-center">
                        <div class="col-md">
                          <label>Name *</label>
                          <input type="text" formControlName="name" placeholder="Guardian Name" class="form-control">
                        </div>
                        <div class="col-md">
                          <label>Relationship to student *</label>
                          <input type="text" formControlName="relationship" placeholder="Relationship" class="form-control">
                        </div>
                        <div class="col-md">
                          <label class="d-block">Is this person aware of evaluation? *</label>
                          <div>
                            <div class="custom-control custom-radio custom-control-inline">
                              <input type="radio" [id]="'awareYes'+i" formControlName="isAware" [value]="true" class="custom-control-input">
                              <label class="custom-control-label" [for]="'awareYes'+i">Yes</label>
                            </div>
                            <div class="custom-control custom-radio custom-control-inline">
                              <input type="radio" [id]="'awareNo'+i" formControlName="isAware" [value]="false" class="custom-control-input">
                              <label class="custom-control-label" [for]="'awareNo'+i">No</label>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-auto text-right" *ngIf="guardians.length > 1">
                          <button type="button" class="btn btn-danger btn-sm" (click)="removeGuardian(i)">&times;</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <button type="button" class="theme-button mt-2" (click)="addGuardian()">Add Another Guardian</button>

                  <div class="consent-block mt-4">
                    <p class="mb-2">By checking the box and signing below, you confirm that:</p>
                    <ul>
                      <li>All individuals with legal decision-making authority listed above have been <strong>fully informed</strong> of this evaluation, <strong><u>and</u></strong></li>
                      <li>Those individuals have <strong>provided consent, </strong>  <strong><u>or</u></strong></li>
                      <li>You have <strong>sole legal authority</strong> to proceed without additional consent.</li>
                    </ul>
                    
                    <div class="custom-control custom-checkbox mt-3">
                      <input type="checkbox" id="consentConfirmation" formControlName="consentConfirmation" class="custom-control-input">
                      <label class="custom-control-label" for="consentConfirmation">I confirm the above is true *</label>
                    </div>

                    <div class="signature-block mt-4">
                      <label>Signature *</label>
                      <div class="signature-pad-container">
                        <canvas #signatureCanvas class="signature-pad"></canvas>
                      </div>
                      <button type="button" class="btn btn-secondary btn-sm mt-2" (click)="clearSignature()">Clear Signature</button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mt-4">
                <div class="row">
                  <div class="col-md-6">
                    <label for="submitterName">Name of Individual submitting this information *</label>
                    <input type="text" formControlName="submitterName" placeholder="Name" class="form-control">
                  </div>
                  <div class="col-md-6">
                    <label>Date</label>
                    <input type="text" [value]="currentDate | date:'MM/dd/yyyy'" readonly class="form-control bg-light">
                  </div>
                </div>
              </div>
            </div>

            <button class="theme-button mt-4 ml-md-auto" type="submit" data-toggle="modal"
              data-target="#comfirmationModal" [ngClass]="{'disable-button' : answersForm.invalid}"
              [disabled]="answersForm.invalid">Submit</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="comfirmationModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="comfirmationModal" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content light px-5 py-4">
      <h6 class="mb-4 text-center">Are you sure you want to submit the form?</h6>
      <div class="action text-center">
        <button [disabled]="disableFormButton" type="submit" (click)="submit()" class="theme-button green mx-2"
          data-dismiss="modal">Yes,
          Continue</button>
        <a href="#!" class="theme-button grey mx-2" data-dismiss="modal">No</a>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="errorModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
  aria-labelledby="errorModal" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content light px-5 py-4">
      <!-- <h6 class="mb-4 text-center">Background form not submitted due to technical failure. Please upload the form again, if issue persists, please contact DLS administration</h6> -->

      <h6 class="mb-4 text-center">Background form request accepted ! </h6>
      <!-- <div class="action text-center">
        <button type="submit" (click)="submit()" class="theme-button green mx-2" data-dismiss="modal">Yes,
          Continue</button>
        <a href="#!" class="theme-button grey mx-2" data-dismiss="modal">No</a>
      </div> -->
    </div>
  </div>
</div>





<div *ngIf="invalidToken">
  <div class="container mt-5 pt-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card p-5 text-center">
          <h4 class="text-green">Form Submitted!</h4>
          <p class="text-grey mb-4">Thank you, we look forward to your appointment.</p>
          <a href="https://www.ltldpodcast.com/" class="theme-button grey mx-auto">Close</a>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple">
  <!-- <p style="color: white">Please Wait... </p> -->
</ngx-spinner>